<div class="row d-flex">
    <canvas id="chartsPuntaje" class="charts"></canvas>
</div>